import type { ExportKind } from "./slice";

export interface PendingExport {
  exportId: number;
  startedAt: number;
}

const PENDING_PREFIX = "ticketExport:pending:";

function storageKey(kind: ExportKind, userId: string | number): string {
  return `${PENDING_PREFIX}${userId}:${kind}`;
}

export function savePendingExport(
  kind: ExportKind,
  userId: string | number,
  data: PendingExport
): void {
  try {
    localStorage.setItem(storageKey(kind, userId), JSON.stringify(data));
  } catch {
    // ignore: private mode / storage disabled
  }
}

export function readPendingExport(
  kind: ExportKind,
  userId: string | number
): PendingExport | null {
  try {
    const raw = localStorage.getItem(storageKey(kind, userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (
      typeof parsed?.exportId !== "number" ||
      typeof parsed?.startedAt !== "number"
    )
      return null;
    return { exportId: parsed.exportId, startedAt: parsed.startedAt };
  } catch {
    return null;
  }
}

export function clearPendingExport(
  kind: ExportKind,
  userId: string | number
): void {
  try {
    localStorage.removeItem(storageKey(kind, userId));
  } catch {
    // ignore
  }
}
